import { render, staticRenderFns } from "./setUserInfoSuccee.vue?vue&type=template&id=a21da1aa&scoped=true&"
import script from "./setUserInfoSuccee.vue?vue&type=script&lang=js&"
export * from "./setUserInfoSuccee.vue?vue&type=script&lang=js&"
import style0 from "./setUserInfoSuccee.vue?vue&type=style&index=0&id=a21da1aa&lang=stylus&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a21da1aa",
  null
  
)

export default component.exports